module.exports = __webpack_public_path__ + "static/media/back_ico_b.feb0319c.svg";